import { Component, inject, RendererFactory2 } from '@angular/core'
import { DOCUMENT, NgClass, NgStyle } from '@angular/common'

interface Color {
  hex: string
  key: string
  label: string
}

@Component({
  selector: 'app-color-selector',
  templateUrl: './color-selector.component.html',
  imports: [
    NgStyle,
    NgClass,
  ],
  styleUrl: './color-selector.component.sass',
})
export class ColorSelectorComponent {
  protected current!: string
  protected colors: Color[] = [
    { key: 'blue', label: $localize`Blau`, hex: '#008faf' },
    { key: 'green', label: $localize`Grün`, hex: '#46af00' },
    { key: 'yellow', label: $localize`Gelb`, hex: '#f3d33a' },
    { key: 'orange', label: $localize`Orange`, hex: '#FFA500' },
    { key: 'red', label: $localize`Rot`, hex: '#c73333' },
    { key: 'purple', label: $localize`Violet`, hex: '#b50ece' },
    { key: 'gold', label: $localize`Gold`, hex: '#cdb97a' },
    { key: 'black', label: $localize`Schwarz`, hex: '#000000' },
  ]
  protected body = inject(DOCUMENT).body

  constructor () {
    this.body.classList.forEach(cls => {
      if (cls.startsWith('e--color-')) {
        this.current = cls.replace('e--color-', '')
      }
    })
  }

  select (color: Color) {
    this.body.classList.forEach(cls => {
      if (cls.startsWith('e--color-')) {
        this.body.classList.remove(cls)
      }
    })
    this.current = color.key
    this.body.classList.add(`e--color-${color.key}`)
  }
}
